<template>
  <div>
    <div class="right_menu">
      <div class="banner" v-show="false">
        <el-carousel class="banner_carousel">
          <el-carousel-item class="el-carousel-item" v-for="(item, index) in banner_list" :key="index"
            :arrow="showArrow">
            <img class="banner_img" :src="item" alt="" @click="showdetail(index)">
            <h3 class="small">{{ item }}</h3>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="delicacy">
        <div class="delicacy_title">场景专用工具</div>
        <div class="delicacy_list" @mouseenter="delicacyHover = true" @mouseleave="delicacyHover = false">
          <div class="left iconfont" :class="{ visible: delicacyHover && currentPage > 0 }" @click="prevDelicacyPage">&#xe645;</div>
          <div class="delicacy_box">
            <div class="del_item" v-for="item in paginatedDelicacyList" :key="item.id"
              @click="del_fun(item.id, $event)">
              <img :src="item.cover" alt="图像未加载">
              <span>{{ item.name }}</span>
              <span></span>
            </div>
          </div>
          <div class="right iconfont" :class="{ visible: delicacyHover && currentPage < totalDelicacyPages - 1 }" @click="nextDelicacyPage">&#xe647;</div>
          <div class="page-dots" v-if="totalDelicacyPages > 1">
            <span v-for="p in totalDelicacyPages" :key="p" class="dot" :class="{ active: currentPage === p - 1 }" @click="currentPage = p - 1"></span>
          </div>
        </div>
      </div>
      <div class="function_title">自由图像编辑</div>
      <div class="function_list" @mouseenter="functionHover = true" @mouseleave="functionHover = false">
        <div class="left iconfont" :class="{ visible: functionHover && functionCurrentPage > 0 }" @click="prevFunctionPage">&#xe645;</div>
        <div class="function_nav">
          <div class="items" v-for="item in paginatedFunctionList" :key="item.id" @click="functionClick(item)">
            <div class="items_info">
              <span>{{ item.title }}</span>
              <span>{{ item.desc }}</span>
            </div>
            <div>
              <img :src="item.img" alt="待加载">
            </div>
          </div>
        </div>
        <div class="right iconfont" :class="{ visible: functionHover && functionCurrentPage < totalFunctionPages - 1 }" @click="nextFunctionPage">&#xe647;</div>
        <div class="page-dots" v-if="totalFunctionPages > 1">
          <span v-for="p in totalFunctionPages" :key="p" class="dot" :class="{ active: functionCurrentPage === p - 1 }" @click="functionCurrentPage = p - 1"></span>
        </div>
      </div>
      <div class="typeof" v-show="false">
        <div class="type_title">
          <span class="iconfont">&#xe600;</span>
          <div>
            <span>风格样式</span>
            <span>Style_&_Pattern</span>
          </div>
        </div>
        <div class="type_list">
          <span class="iconfont" @click="toggleparent_node('全部模型')">&#xe623; 全部模型</span>
          <span class="iconfont" @click="toggleparent_node('模特')">&#xe622; 海报模特</span>
          <span class="iconfont" @click="toggleparent_node('美甲')">&#xe774; 手图生成</span>
          <span class="iconfont" @click="toggleparent_node('海报')">&#xe659; 海报生成</span>
          <span class="iconfont" @click="toggleparent_node('美甲')">&#xe683; 美甲生成</span>
        </div>
      </div>
      <div class="parent_node" @click="warning" v-show="false">
        <div class="node" v-show="item.show && item.property !== 'Lora F.1'" v-for="item in parent_node" :key="item.id" :data-id="item.id"
          @click="map_router(item.id)">
          <div class="cover_top">
            <div class="property">{{ item.property }}</div>
            <span class="cover">
              <img :src="item.img" alt="图像未加载">
            </span>
            <div class="cover_bottom">
              <span class="title iconfont">&#xed1b; {{ item.title }}</span>
              <span class="same iconfont" @click="map_router(item.id)">&#xe621; 一键同款</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <eleva-tor :scrollValue=scrollValue @back="handleBack"></eleva-tor>
  </div>
</template>
<script>
import setLocalStorage from '@/utils/setLocalStorage'
import { Message } from 'element-ui'
import theme from '@/utils/theme'

export default {
  name: 'HomePage',
  data() {
    return {
      show: true,
      msg: 'Welcome to More_Joy',
      list: 5,
      showArrow: 'always',
      parent_node: null,
      template_list: null,
      banner_list: [
        'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/banner/banner-1.jpg',
        'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/banner/banner-2.png',
        'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/banner/banner-3.png',
        'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/banner/banner-4.png'
      ],
      currentIndex: 0,
      currentTranslateX: 0,
      delicacy_list: null,
      delicacyHover: false,
      functionHover: false,
      functionCurrentPage: 0,
      currentPage: 0,
      day: theme.day,
      night: theme.night,
      theme: true,
      process_lock: false,
      function_list: [
        { id: 'matting', title: 'AI-智能抠图', desc: '抠出主体,精准无痕', img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/funciton/matting.jpg', route: '/function' },
        { id: 'cut_picture', title: 'AI-局部重绘', desc: '一键重绘,化繁为简', img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/funciton/againimage.png', route: '/partialredraw' },
        { id: 'broadpicture', title: 'AI-无界扩图', desc: '视觉扩展,AI上未知', img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/funciton/padimage.jpg', route: '/broadpicture' },
        { id: 'realistic', title: 'AI-高清放大', desc: '细节重现,修复低画质', img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/funciton/realhd.jpg', route: '/realistichd' },
        { id: 'videomatting', title: 'AI-视频抠像', desc: '万千视觉,准确抠像', img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/funciton/Videomatting.png', route: '/videomatting' },
        { id: 'videoupscale', title: 'AI-视频放大', desc: '效果自然,一键放大', img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/funciton/repair.jpg', route: '/videoupscale' },
        { id: 'VideoSound', title: 'AI-视频音效', desc: '帧帧精彩,音效动人', img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/funciton/VideoSound.png', route: '/videosound' },
        { id: 'ProductSplicing', title: 'AI-产品拼接', desc: '效果自然,一键生成', img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/funciton/Productsplicing.png', route: '/productsplicing' },
        { id: 'ImageSegmentation', title: '图片分割', desc: '分割图片，提取对象', img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/funciton/ImageSegmentation.png', route: '/imagesegmentation' },
        { id: 'FingernailChange', title: 'AI-甲片迁移', desc: '甲片迁移,一键换款', img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/funciton/Onychomycosis.png', route: '/nailtiptransfer' },
        { id: 'AutoCrop', title: '自动裁剪', desc: '自动裁剪,一键生成', img: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/funciton/AutoCrop.png', route: '/autocrop' }
      ],
      scrollValue: 0, // 滚动条位置
      visibleNodes: new Set(), // 用于存储当前应该显示的节点ID
      observer: null // 用于存储 IntersectionObserver 实例
    }
  },
  computed: {
    // 过滤显示的场景专用工具列表
    filteredDelicacyList() {
      if (!this.delicacy_list) return []
      return this.delicacy_list.filter(item => item.show !== false)
    },
    // 总页数（每页8个，2行4列）
    totalDelicacyPages() {
      return Math.ceil(this.filteredDelicacyList.length / 8)
    },
    // 当前页显示的项目
    paginatedDelicacyList() {
      const start = this.currentPage * 8
      return this.filteredDelicacyList.slice(start, start + 8)
    },
    filteredFunctionList() {
      return this.function_list.filter(item => item.show !== false)
    },
    totalFunctionPages() {
      return Math.ceil(this.filteredFunctionList.length / 8)
    },
    paginatedFunctionList() {
      const start = this.functionCurrentPage * 8
      return this.filteredFunctionList.slice(start, start + 8)
    }
  },
  async created() {
    // 请求仓库的封面
    this.$store.dispatch('parent_node/selectTable')
    this.parent_node = this.$store.getters['parent_node/sourceHomePageCover']
    this.delicacy_list = (this.$store.state.premium_app.app_list)
    this.theme = setLocalStorage.getItem('theme')
    if (this.theme === '' || this.theme === null) {
      this.theme = true
    }
    await this.$store.dispatch('template_list/getTemplateList')
    this.template_list = this.$store.getters['template_list/getterTemplateList']
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver()
      }, 100)
    })
  },
  mounted() {
    // 已弃用
    this.$nextTick(() => {
      this.source_html()
      // 实验室
      const light = document.querySelector('#light')
      // 按钮
      const label = document.querySelector('.label')
      const darktips = document.querySelector('.darktips')
      const daytips = document.querySelector('.daytips')
      // 搜索框
      const serarch = document.querySelector('.search')
      if (this.theme === false) {
        if (label) label.style.paddingLeft = '60%'
        if (darktips) darktips.style.opacity = 1
        if (daytips) daytips.style.opacity = 0
        if (light) light.style.color = 'gray'
        if (serarch && serarch.childNodes[0]) serarch.childNodes[0].style.border = '1px solid gray'
      } else {
        if (label) label.style.paddingLeft = '1%'
        if (darktips) darktips.style.opacity = 0
        if (daytips) daytips.style.opacity = 1
        if (light) light.style.color = 'black'
        if (serarch && serarch.childNodes[0]) serarch.childNodes[0].style.border = ''
      }
    })
    const rightMenu = document.querySelector('.right_menu')
    if (rightMenu) {
      rightMenu.addEventListener('scroll', this.handleScroll)
    }
  },
  beforeDestroy() {
    const rightMenu = document.querySelector('.right_menu')
    if (rightMenu) {
      rightMenu.removeEventListener('scroll', this.handleScroll)
    }
    this.destroyIntersectionObserver()
  },
  methods: {
    // 返回最顶部
    handleBack() {
      const rightMenu = document.querySelector('.right_menu')
      rightMenu.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    // 获取滚动条滚动位置的方法
    handleScroll(event) {
      const scrollTop = Math.round(event.target.scrollTop)
      this.scrollValue = scrollTop
    },
    toggleparent_node(parameter) {
      this.parent_node.forEach(element => {
        element.show = true
      })
      this.parent_node.forEach(element => {
        if (!element.title.includes(parameter)) {
          element.show = false
        }
        if (parameter === '全部模型' || parameter === '') {
          this.parent_node.forEach(element => {
            element.show = true
          })
        }
      })
    },
    map_router(index) {
      this.template_list.forEach(element => {
        if (element.id === index) {
          if (element.id === 26) {
            return
          }
          this.$router.push({
            path: '/normaltemp',
            query: {
              id: element.id,
              img1: element.img1,
              img2: element.img2,
              localstoragename: element.localstoragename,
              ckptname: element.ckptname,
              loraname: element.loraname,
              default: element.default,
              english: element.english,
              chinese: element.chinese,
              width: element.width,
              height: element.height,
              steps: element.steps,
              guidance: element.guidance,
              weight: element.weight,
              genid: element.genid, // 添加生成id
              video_demo: element.video_demo
            }
          })
        }
        if (element.id === 6 && index === 6) {
          this.$router.push({ path: '/morejoy' })
        }
        if (element.class === 'SD1.5' && element.id === index) {
          this.$router.push({
            path: '/commonsd1.5',
            query: {
              id: element.id,
              img1: element.img1,
              img2: element.img2,
              localstoragename: element.localstoragename,
              ckptname: element.ckptname,
              loraname: element.loraname,
              default: element.default,
              english: element.english,
              chinese: element.chinese,
              width: element.width,
              height: element.height,
              genid: element.genid,
              video_demo: element.video_demo
            }
          })
        }
        if (element.class === 'SDXL' && element.id === index) {
          this.$router.push({
            path: '/commonsdxl',
            query: {
              id: element.id,
              img1: element.img1,
              img2: element.img2,
              localstoragename: element.localstoragename,
              ckptname: element.ckptname,
              loraname: element.loraname,
              default: element.default,
              english: element.english,
              chinese: element.chinese,
              width: element.width,
              height: element.height,
              genid: element.genid,
              cfg: element.cfg,
              steps: element.steps,
              galleryname: element.galleryname,
              video_demo: element.video_demo
            }
          })
        }
        if (element.class === 'FluxI2I' && element.id === index) {
          this.$router.push({
            path: '/fluximage2image',
            query: {
              id: element.id,
              img1: element.img1,
              img2: element.img2,
              localstoragename: element.localstoragename,
              ckptname: element.ckptname,
              loraname: element.loraname,
              default: element.default,
              english: element.english,
              chinese: element.chinese,
              width: element.width,
              height: element.height,
              steps: element.steps,
              guidance: element.guidance,
              weight: element.weight,
              genid: element.genid, // 添加生成id,
              gallery: element.galleryname,
              video_demo: element.video_demo
            }
          })
        }
      })
    },
    matting() {
      this.$router.push({
        path: '/function'
      })
    },
    videomatting() {
      this.$router.push({
        path: '/videomatting'
      })
    },
    flux_p2image() {
      this.$router.push({
        path: '/index/imageGeneration'
      })
    },
    flux_i2image() {
      this.$router.push({
        path: '/index/generate/promptimage'
      })
    },
    broadpicture() {
      this.$router.push({
        path: '/broadpicture'
      })
    },
    removecontainer() {
      this.$router.push({
        path: '/removecontainer'
      })
    },
    videoupscale() {
      this.$router.push({
        path: '/videoupscale'
      })
    },
    realistic() {
      this.$router.push({
        path: '/realistichd'
      })
    },
    wan_vedio() {
      alert('正在开发中,敬请期待!')
    },
    VideoSound() {
      this.$router.push({
        path: '/videosound'
      })
    },
    ProductSplicing() {
      this.$router.push({
        path: '/productsplicing'
      })
    },
    cut_picture() {
      this.$router.push({
        path: '/partialredraw'
      })
    },
    warning(event) {
      if (event.target === event.currentTarget) {
        // 执行返回操作
        return
      }
      Message.warning('o(*￣▽￣*)ブ开发者正在开发中,敬请期待😋!')
    },
    showdetail(index) {
      if (index === 0) {
        window.open('https://alidocs.dingtalk.com/i/nodes/kDnRL6jAJM3L7x9xTDlL9p2KWyMoPYe1?corpId=ding2eed5fbb8a1fa516&utm_medium=im_card&doc_type=wiki_doc&iframeQuery=utm_medium%3Dim_card%26utm_source%3Dim&utm_scene=team_space&utm_source=im&cid=65824995641')
      }
      if (index === 1) {
        this.$router.push({
          path: '/imageeditindex/kontext_v1'
        })
      }
      if (index === 2) {
        this.$router.push({
          path: '/index/appdownload'
        })
      }
      if (index === 3) {
        this.$emit('show', true)
      }
    },
    template_title(index) {
      return this.title_list[index]
    },
    prevDelicacyPage() {
      if (this.currentPage > 0) {
        this.currentPage--
      }
    },
    nextDelicacyPage() {
      if (this.currentPage < this.totalDelicacyPages - 1) {
        this.currentPage++
      }
    },
    prevFunctionPage() {
      if (this.functionCurrentPage > 0) {
        this.functionCurrentPage--
      }
    },
    nextFunctionPage() {
      if (this.functionCurrentPage < this.totalFunctionPages - 1) {
        this.functionCurrentPage++
      }
    },
    functionClick(item) {
      if (item.route) {
        this.$router.push({ path: item.route })
      }
    },
    // 精品应用
    del_fun(id, event) {
      if (id === 0) {
        event.stopPropagation()
        this.$router.push({
          path: '/imageeditindex'
        })
      }
      if (id === 1) {
        event.stopPropagation()
        this.$router.push({
          path: '/fingernailchange'
        })
      }
      if (id === 2) {
        event.stopPropagation()
        this.$router.push({
          path: '/handsrecover'
        })
      }
      if (id === 3) {
        event.stopPropagation()
        this.$router.push({
          path: '/multianglegeneration'
        })
      }
      if (id === 6) {
        event.stopPropagation()
        this.$router.push({
          path: '/videogeneration'
        })
      }
      if (id === 7) {
        event.stopPropagation()
        this.$router.push({
          path: '/testfingernailchange'
        })
      }
      if (id === 8) {
        event.stopPropagation()
        this.$router.push({
          path: '/productretouching'
        })
      }
      if (id === 9) {
        event.stopPropagation()
        this.$router.push({
          path: '/videoscriptreverse'
        })
      }
      if (id === 10) {
        event.stopPropagation()
        this.$router.push({
          path: '/colorcardretouching'
        })
      }
      if (id === 4) {
        event.stopPropagation()
        this.$router.push({
          path: '/videoclip'
        })
      }
      if (id === 5) {
        event.stopPropagation()
        this.$router.push({
          path: '/universalmigrate'
        })
      }
      if (id === 11) {
        event.stopPropagation()
        this.$router.push({
          path: '/blendimage'
        })
      }
      if (id === 12) {
        event.stopPropagation()
        this.$router.push({
          path: '/videostitching'
        })
      }
    },
    // 初始化效果
    source_html() {
      const html = document.querySelector('html')
      // 夜间要切换的元素
      // 左侧导航
      const navigation = document.querySelectorAll('.navigation .nav-item')
      // 右边页面
      const right_menu = document.querySelectorAll('.right_menu')
      // 精品应用
      const delecacy = document.querySelector('.delicacy_title')

      // 风格样式
      const type_list = document.querySelector('.typeof')

      // 标题栏
      const header = document.querySelector('header')

      // 侧边栏
      const left = document.querySelector('.left_menu')

      // 搜索框
      const serarch = document.querySelector('.search')

      // 实验室
      const light = document.querySelector('#light')

      // 按钮
      const label = document.querySelector('.label')
      const darktips = document.querySelector('.darktips')
      const daytips = document.querySelector('.daytips')
      if (this.theme === false) {
        html.style.backgroundColor = this.night
        try {
          navigation.forEach(element => {
            element.style.color = 'gray'
          })
          right_menu.forEach(element => {
            element.style.opacity = 0.75
          })
          delecacy.style.color = 'gray'
          type_list.style.color = 'gray'
          type_list.childNodes.forEach(element => {
            element.style.color = 'gray'
          })
          header.style.borderBottom = '1px solid gray'
          left.style.borderRight = '1px solid gray'
          serarch.childNodes[0].style.border = '1px solid gray'
          light.children[0].style.color = 'gray'

          label.style.paddingLeft = '60%'
          darktips.style.opacity = 1
          daytips.style.opacity = 0
        } catch (error) {
        }
      } else {
        html.style.backgroundColor = this.day
        try {
          navigation.forEach(element => {
            element.style.color = ''
          })
          right_menu.forEach(element => {
            element.style.opacity = 1
          })
          delecacy.style.color = ''
          type_list.style.color = ''
          type_list.childNodes.forEach(element => {
            element.style.color = ''
          })

          header.style.borderBottom = ''
          left.style.borderRight = ''
          serarch.childNodes[0].style.border = ''
          light.children[0].color = 'black'

          label.style.paddingLeft = '4%'
          darktips.style.opacity = 0
          daytips.style.opacity = 1
        } catch (e) {
        }
      }
    },

    initIntersectionObserver() {
      this.$nextTick(() => {
        const nodes = document.querySelectorAll('.node')
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              const nodeId = parseInt(entry.target.dataset.id)
              if (entry.isIntersecting) {
                this.visibleNodes.add(nodeId)
                entry.target.classList.add('fade-in')
              } else {
                this.visibleNodes.delete(nodeId)
                entry.target.classList.remove('fade-in')
              }
            })
          }, {
            root: document.querySelector('.right_menu'),
            rootMargin: '50px', // 提前50px触发
            threshold: 0.1
          })

          nodes.forEach(node => {
            this.observer.observe(node)
            // 立即检查元素是否已在视口中
            const rect = node.getBoundingClientRect()
            const rootRect = document.querySelector('.right_menu').getBoundingClientRect()
            if (
              rect.top < rootRect.bottom &&
              rect.bottom > rootRect.top
            ) {
              // 元素已经在视口中
              node.classList.add('fade-in')
              this.visibleNodes.add(parseInt(node.dataset.id))
            }
          })
        } else {
          // 如果浏览器不支持 IntersectionObserver，则默认全部显示
          this.parent_node.forEach(item => {
            this.visibleNodes.add(item.id)
          })
        }
      })
    },

    destroyIntersectionObserver() {
      if (this.observer) {
        this.observer.disconnect()
      }
    }
  }
}

</script>
<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 23px
}

.right_menu {
  width: calc(100vw - 360px);
  height: calc(100vh - 95px);
  padding: 0 100px;
  overflow-y: scroll;
  overflow-x: hidden;
  color: @font_white;
  scrollbar-width: thin;
  scrollbar-color: @basicselect transparent;

  .banner {
    width: calc(100vw - 510px);
    height: 320px;
    border-radius: @border_radius;
    margin-top: 10px;
    overflow: hidden;
    transition: all 0.5s;

    .banner_carousel {
      width: 100%;
      height: 100%;

      .el-carousel-item {
        width: 100%;
        height: 320px;
      }

      .banner_img {
        width: 100%;
        height: 100%;
      }
    }

    .el-carousel__item h3 {
      color: @basecolor;
      font-size: 25px;
      opacity: 0.75;
      line-height: 210px;
      margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
      background-color: @basecolor;
    }

    .el-carousel__item:nth-child(2n+1) {
      background-color: @basecolor;
    }
  }

  .function_title {
    color: @font_black;
    font-size: 32px;
    font-weight: 600;
    height: 60px;
    margin-top: 35px;
  }

  .function_list {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: calc(100vw - 500px);
    height: 367px;

    .left,
    .right {
      position: absolute;
      width: 50px;
      height: 80px;
      border-radius: 25px;
      background-color: rgb(82, 82, 82);
      font-size: 18px;
      text-align: center;
      line-height: 80px;
      z-index: 5;
      cursor: pointer;
      transition: all 0.3s;
      opacity: 0;
      top: 50%;
      transform: translateY(-60%);

      &.visible {
        opacity: 0.6;
      }

      &:hover {
        font-size: 22px;
        opacity: 0.85;
      }
    }

    .left {
      left: -30px;
    }

    .right {
      right: -30px;
    }

    .page-dots {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -25px;
      display: flex;
      gap: 8px;

      .dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #ccc;
        cursor: pointer;
        transition: all 0.3s;

        &.active {
          background: @morejoy;
          transform: scale(1.2);
        }

        &:hover {
          background: @morejoy;
          opacity: 0.7;
        }
      }
    }
  }

  .function_nav {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0;
    gap: 10px;
    width: calc(100vw - 510px);
    overflow: visible;
    scrollbar-width: none;
    justify-content: stretch;
    margin-top: 5px;

    .items {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      padding: 8px 8px 8px 30px;
      width: 505px;
      height: 170px;
      background-color: @basicselect;
      border-radius: @border_radius;
      cursor: pointer;
      transition: all 0.5s;

      .items_info {
        height: 160px;
        width: 235px;
        justify-content: space-evenly;
        align-items: center;
        overflow: hidden;

        span {
          display: block;
          height: 20px;
          padding: 5px;

          &:nth-child(1) {
            color: @font_black;
            font-size: 25px;
            margin-top: 35px;
          }

          &:nth-child(2) {
            font-size: 20px;
            color: rgb(108, 108, 108);
            margin-top: 15px;
          }
        }
      }

      div {
        position: relative;
        width: 155px;
        height: 155px;
        overflow: hidden;
        border-radius: @border_radius;

        &:hover img {
          transform: scale(1.1);
        }

        img {
          position: absolute;
          width: 160px;
          height: 160px;
          border: none;
          border-radius: @border_radius;
          text-align: center;
          line-height: 140px;
          transition: all 0.5s;
        }

        .one {
          position: absolute;
          width: 160px;
          height: 160px;
          border: none;
          border-radius: @border_radius;
          text-align: center;
          line-height: 140px;
          transition: all 0.5s;
          opacity: 1;
          z-index: 2;

          &:hover {
            opacity: 0;
          }
        }

        .two {
          position: absolute;
          width: 160px;
          height: 160px;
          border: 0px solid rgb(241, 255, 0);
          border-radius: @border_radius;
          background-color: gray;
          text-align: center;
          line-height: 140px;
          transition: all 0.5s;
          opacity: 1;
          z-index: 1;
        }
      }
    }
  }

  .delicacy {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: calc(100vw - 500px);

    .delicacy_title {
      display: flex;
      align-items: center;
      color: @font_black;
      font-size: 32px;
      font-weight: 600;
      height: 100px;
    }

    .delicacy_list {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      width: calc(100vw - 510px);

      .left,
      .right {
        position: absolute;
        width: 50px;
        height: 80px;
        border-radius: 25px;
        background-color: rgb(82, 82, 82);
        font-size: 18px;
        text-align: center;
        line-height: 80px;
        z-index: 5;
        cursor: pointer;
        transition: all 0.3s;
        opacity: 0;
        top: 50%;
        transform: translateY(-60%);

        &.visible {
          opacity: 0.6;
        }

        &:hover {
          font-size: 22px;
          opacity: 0.85;
        }
      }

      .left {
        left: -30px;
      }

      .right {
        right: -30px;
      }

      .delicacy_box {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(2, 250px);
        gap: 12px;
        width: 100%;

        .del_item {
          position: relative;
          border-radius: @border_radius;
          text-align: center;
          overflow: hidden;
          transition: all 0.5s;
          cursor: pointer;

          &:hover img {
            transform: scale(1.05);
            transition: all 0.5s;
          }

          img {
            width: 100%;
            height: 100%;
            font-size: 16px;
            transition: all 0.5s;
            object-fit: cover;
            z-index: 1;

            &:hover {
              transition: all 0.5s;
            }
          }

          span:nth-child(2) {
            display: block;
            position: absolute;
            font-size: 20px;
            font-weight: 500;
            left: 15px;
            bottom: 15px;
            z-index: 3;
            color: @font_white;
          }

          span:nth-child(3) {
            display: block;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: 2;
            background: linear-gradient(to top, #000000, #40404038, #80808041);
            opacity: 0.95;
          }

          &:hover {
            transition: all 0.5s;
            box-shadow: 0 0 8px 3px rgba(108, 108, 108, 0.2);
          }
        }
      }

      .page-dots {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -25px;
        display: flex;
        gap: 8px;

        .dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #ccc;
          cursor: pointer;
          transition: all 0.3s;

          &.active {
            background: @morejoy;
            transform: scale(1.2);
          }

          &:hover {
            background: @morejoy;
            opacity: 0.7;
          }
        }
      }
    }

  }

  .typeof {
    display: flex;
    flex-direction: column;
    gap: 10px 0;
    height: 110px;
    width: 100vw;
    margin-bottom: 30px;
    color: @font_black;

    .type_title {
      display: flex;
      height: 200px;
      font-weight: 600;
      gap: 0px;
      justify-content: start;
      align-items: center;

      span {
        display: inline-block;
        font-size: 0px;
      }

      div {
        display: flex;
        flex-direction: column;

        span {
          display: inline-block;
        }

        span:nth-child(1) {
          font-size: 32px;
        }

        span:nth-child(2) {
          font-size: 0px;
        }
      }
    }

    .type_list {
      display: flex;
      height: 30px;
      align-items: center;
      gap: 0 20px;
      color: @font_black;

      span {
        display: inline-block;
        font-size: 20px;
        line-height: 30px;
        padding: 10px 20px;
        cursor: pointer;
        border-radius: @border_radius_2;

        &:hover {
          transition: all 0.5s;
          box-shadow: 0 0 8px 3px @basicselect;
          font-size: 21px;
        }
      }
    }
  }

  .parent_node {
    display: flex;
    width: calc(100vw - 500px);
    height: auto;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: stretch;

    .node {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 505px;
      height: 756px;
      border-radius: @border_radius;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.5s;
      opacity: 0;
      transform: translateY(20px) scale(0.8);
      transition: opacity 0.5s ease, transform 0.5s ease;

      &.fade-in {
        opacity: 1;
        transform: translateY(0) scale(1);
      }

      &:hover {
        transition: all 0.5s;
        box-shadow: 0 0 8px 3px rgba(108, 108, 108, 0.4);
      }

      &:hover img {
        transform: scale(1.15);
      }

      .cover_top {
        width: 100%;
        height: 100%;
        position: relative;

        .property {
          position: absolute;
          padding: 5px 20px;
          font-size: 18px;
          top: 15px;
          left: 15px;
          z-index: 3;
          background-color: rgba(22, 22, 22, 0.2);
          backdrop-filter: blur(10px);
          border-radius: 18px;
        }

        .cover {
          img {
            width: 100%;
            height: 100%;
            transition: all 0.5s;
            z-index: 2;
          }
        }

        .cover_bottom {
          position: absolute;
          padding: 0 15px;
          bottom: 15px;
          display: flex;
          justify-content: space-between;
          width: 100%;
          height: 50px;
          z-index: 3;

          .title {
            display: inline-block;
            padding: 10px;
            font-size: 20px;
            background-color: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            border-radius: @border_radius_3;
          }

          .same {
            display: inline-block;
            padding: 10px;
            font-size: 20px;
            background-color: @morejoy;
            backdrop-filter: blur(10px);
            border-radius: @border_radius_3;
            transition: all 0.5s;

            &:hover {
              padding: 10px 15px;
            }
          }
        }
      }
    }
  }

  .bottom {
    display: inline-block;
    width: calc(100vw - 500px);
    height: 50px;
    color: @font_gray;
    text-align: center;
    font-size: 23px;
    line-height: 50px;
    opacity: 0.75;
  }
}
</style>
